export enum MfDocumentType {
    PORTFOLIO_PAPER = 'PORTFOLIO_PAPER',
    DOCUMENT = 'DOCUMENT',
}
